
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import Vue from "vue";
export default Vue.extend({
	props: {
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		},
		lang: String
	},
	computed: {
		hasHeaders():boolean {
			for (let col of this.layout.Cols){
				if (col.getHeadingText(this.lang)){
					return true;
				}
			}
			return false;
		}
	},
	methods: {
		getHeadingStyle(i:number):any{
			let col = this.layout.Payments.Cols[i];
			if (!col) return null;
			if (!col.HeaderField) return null;
			let result = col.HeaderField.Style.getStyle();
			result.width = col.getWidth();
			result.left = col.getHeaderPosition(this.layout.Payments.Cols);
			return result;
		},
		getStyle(i:number):any {
			let col = this.layout.Payments.Cols[i];
			if (!col) return null;
			let result = col.Style.getStyle();
			result.width = col.getWidth();
			result.left = col.getPosition(this.layout.Payments.Cols);
			return result;
		}
	}
});
